import React from 'react';
import { FormattedMessage } from 'react-intl';
import {
    ProductIcon, SeminarIcon, FAQIcon, ListedIcon, CheckIcon, LiveStreamIcon, ListLivestreamRegistered, SettingShopping,
} from '../../components/Icons/Icon';

const userRoutes = [
    {
        path: '/exhibitors',
        param: ':shortName',
        name: <FormattedMessage id="userRoutes.organizerListNewName" />,
        icon: ProductIcon,
        customName: 'exhibitor_info_list',
    },
    {
        path: '/exhibitor-posters',
        param: ':shortName',
        name: <FormattedMessage id="userRoutes.posterListNewName" />,
        icon: CheckIcon,
        customName: 'list_companies_want_see',
        text_type: 2,
    },
    {
        path: '/list-seminar',
        param: ':shortName',
        name: <FormattedMessage id="userRoutes.seminarList" />,
        isActiveFunc: (match, location) => {
            const seminarListRegex = /^\/.*\/seminars$/;
            const detailSeminarRegex = /^\/.*\/seminars\/.*\d$/;
            const seminarNonAuthRegex = /^\/.*\/list-seminar$/;
            return seminarListRegex.test(location.pathname) || detailSeminarRegex.test(location.pathname) || seminarNonAuthRegex.test(location.pathname);
        },
        icon: SeminarIcon,
        customName: 'seminar_list',
        text_type: 1,
    },
    {
        path: '/seminars',
        param: ':shortName',
        name: <FormattedMessage id="userRoutes.seminarList" />,
        isActiveFunc: (match, location) => {
            const seminarListRegex = /^\/.*\/seminars$/;
            const detailSeminarRegex = /^\/.*\/seminars\/.*\d$/;
            const seminarNonAuthRegex = /^\/.*\/list-seminar$/;
            return seminarListRegex.test(location.pathname) || detailSeminarRegex.test(location.pathname) || seminarNonAuthRegex.test(location.pathname);
        },
        icon: SeminarIcon,
        customName: 'seminar_list',
        text_type: 1,
    },
    {
        path: '/seminar_registered',
        param: ':shortName',
        name: <FormattedMessage id="userRoutes.registeredSeminarListNewName" />,
        icon: ListedIcon,
        isActiveFunc: (match, location) => {
            const seminarList = /^\/.*\/seminar_registered$/;
            const detailSeminar = /^\/.*\/seminar_registered\/.*\d$/;
            return seminarList.test(location.pathname) || detailSeminar.test(location.pathname);
        },
        customName: 'application_list',
        text_type: 1,
    },
    {
        path: '/live_stream',
        param: ':shortName',
        name: <FormattedMessage id="userRoutes.liveStream" />,
        icon: LiveStreamIcon,
        customName: 'livestreaming',
        text_type: 0,
    },
    {
        path: '/live-stream-registered',
        param: ':shortName',
        name: <FormattedMessage id="userRoutes.liveStreamRegister" />,
        icon: ListLivestreamRegistered,
        customName: 'livestream_application_list',
        text_type: 0,
    },
    {
        path: '/shopping-cart',
        param: ':shortName',
        name: <FormattedMessage id="userRoutes.cart" />,
        icon: SettingShopping,
        isCheckCount: true,
        customName: 'cart',
        text_type: 2,
    },
    {
        path: '/QA',
        param: ':shortName',
        name: <FormattedMessage id="userRoutes.faq" />,
        icon: FAQIcon,
        customName: 'faq',
        text_type: 3,
    },
];

export default userRoutes;
